import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ThumbsUp from '@deliveroo/icon-set/react/ThumbsUp';
import ThumbsDown from '@deliveroo/icon-set/react/ThumbsDown';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import P from '@deliveroo/consumer-component-library/components/P';
import styles from './styles.scss';

class OrderHelpScore extends Component {
  constructor(props) {
    super(props);

    this.onFeedbackClick = this.onFeedbackClick.bind(this);
  }

  onFeedbackClick(event) {
    event.preventDefault();
    const scoreValue = event.currentTarget.value;
    const score = this.props.options.find((option) => option.id === scoreValue);
    this.props.onSelectScore(score.id, score.submit_url);
  }

  render() {
    return (
      <div className={classnames(styles.score, { [styles.modal]: this.props.iframe })}>
        <P spacing="0 0 medium 0">{this.props.title}</P>

        {this.props.options.map((score) => {
          const [button, icon, iconComponent] =
            score.id === 'positive'
              ? ['feedback-btn-positive', 'thumbs-up', ThumbsUp]
              : ['feedback-btn-negative', 'thumbs-down', ThumbsDown];

          return (
            // eslint-disable-next-line react/button-has-type
            <button
              className={styles[button]}
              value={score.id}
              key={score.id}
              onClick={this.onFeedbackClick}
            >
              <span className={styles[icon]}>
                <Icon size={24} component={iconComponent} />
              </span>
            </button>
          );
        })}
      </div>
    );
  }
}

OrderHelpScore.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      submit_url: PropTypes.string,
    }),
  ).isRequired,
  onSelectScore: PropTypes.func.isRequired,
  iframe: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

OrderHelpScore.defaultProps = {
  iframe: false,
};

export default OrderHelpScore;
